import { render, staticRenderFns } from "./GameSettingsModal.vue?vue&type=template&id=71a23420&"
import script from "./GameSettingsModal.vue?vue&type=script&lang=js&"
export * from "./GameSettingsModal.vue?vue&type=script&lang=js&"
import style0 from "./GameSettingsModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports